<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex flex-grow-1">
      <!-- LOGO -->
      <app-logo></app-logo>

      <button
        id="vertical-menu-btn"
        type="button"
        class="btn font-size-24 header-item"
        (click)="onToggleMobileMenu()"
      >
        <i class="bx bx-menu"></i>
      </button>

      <div id="sub-menu" class="d-flex flex-grow-1 align-items-center gap-3">
        <ng-container *ngIf="role$ | async as role">
          <ng-container *ngIf="role === 'COMMUNITY_RESIDENT'">
            <button class="btn btn-soft-primary d-none d-md-inline-block" (click)="onCustomEvent()">
              Create Custom Event
            </button>

            <button
              class="btn btn-soft-primary d-none d-md-inline-block"
              (click)="onConversation()"
            >
              New Conversation
            </button>
          </ng-container>
          <ng-container *ngIf="role === 'COMMUNITY_RELATIVE'">
            <ng-container *ngIf="resident">
              <ng-container *ngIf="residents$ | async as residents">
                <div class="w-100">
                  <div class="row align-items-center g-2">
                    <div class="col-auto">
                      <div [style.width]="'40px'">
                        <div class="border border-secondary rounded-circle border-2 gallery-image">
                          <img
                            [src]="
                              resident.profile.media
                                ? resident.profile.media.url
                                : 'https://dummyimage.com/300/ebebeb/bdbdbd.jpg?text=Unavailable'
                            "
                            (error)="onImageError($event)"
                            class="img-fluid rounded-circle"
                            alt="..."
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <select class="form-select" [value]="resident.id" (change)="onChange($event)">
                        <option *ngFor="let item of residents" [value]="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col">
                      <button
                        class="btn btn-soft-primary d-none d-md-inline-block"
                        (click)="onAddResident()"
                      >
                        Add Another Resident
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="d-flex flex-shrink-1">
      <app-notifications-dashboard></app-notifications-dashboard>
      <app-profile></app-profile>
    </div>
  </div>
</header>
